import { render, staticRenderFns } from "./considerDialog.vue?vue&type=template&id=ca522db0&"
import script from "./considerDialog.vue?vue&type=script&lang=js&"
export * from "./considerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports